import { showSnackbar } from '@lyearn-team/frontend-components/dist/showSnackbar/showSnackbar';

function showErrorPopup() {
  showSnackbar({
    label: 'Something went wrong, please RELOAD the app if you face any issues.',
    duration: 15,
    buttons: [{ onClick: () => window.location.reload(true), label: 'Reload' }]
  });
}

export default class ErrorPopup {
  static init() {
    window.showErrorPopup = showErrorPopup;
    global.showErrorPopup = showErrorPopup;
  }
}
